module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/e-photo-location-og-image-98f5d30a1d87fce04e77a87dd2c9d920.jpg";